/*============================================================================
  DiamondBoss: "Edit ring" from the cart
  ----------------------------------------------------------------------------
  The cart links to the product page with ?variant=<id>&db_edit=<line key>.
  Here we fill the options app's controls (ring size, clarity, colour,
  engraving, upgrades, gemstone) from that cart line, show a short banner and
  label the button "Update ring". When the shopper adds the ring again, we
  remember the old line; assets/db-addon-sync.js then removes it (and its
  upgrade charges) once the new line is in the cart.
==============================================================================*/
;(function () {
  var params = new URLSearchParams(window.location.search)
  var editKey = params.get('db_edit')
  if (!editKey) return
  var PENDING = 'dbEditRing'

  function setControl(name, value) {
    var els = [].slice.call(document.querySelectorAll('[name]')).filter(function (el) {
      return el.name === name && el.type !== 'hidden' && el.closest('.avp-option')
    })
    if (!els.length) return false
    var el = els[0]
    if (el.tagName === 'SELECT') {
      if (el.value !== value) {
        el.value = value
        el.dispatchEvent(new Event('change', { bubbles: true }))
      }
    } else if (el.type === 'checkbox' || el.type === 'radio') {
      var wanted = String(value).split(',').map(function (v) { return v.trim() })
      els.forEach(function (box) {
        var on = wanted.indexOf(box.value.trim()) !== -1
        if (on !== box.checked) box.click()
      })
    } else {
      el.value = value
      el.dispatchEvent(new Event('input', { bubbles: true }))
      el.dispatchEvent(new Event('change', { bubbles: true }))
    }
    return true
  }

  function prefill(line, tries) {
    if (!document.querySelector('.avp-option')) {
      // The options app renders after page load
      if (tries < 40) setTimeout(function () { prefill(line, tries + 1) }, 250)
      return
    }
    var props = line.properties || {}
    Object.keys(props).forEach(function (name) {
      if (name.charAt(0) === '_' || props[name] === '' || props[name] == null) return
      setControl(name, String(props[name]))
    })
  }

  function decorate(line) {
    var form = document.querySelector('form[action*="/cart/add"]')
    var btn = form && form.querySelector('[name="add"]')
    if (!form || !btn) return

    var banner = document.createElement('div')
    banner.className = 'db-edit-banner'
    banner.innerHTML = 'Editing the ring in your cart. Change any choices, then tap <strong>Update ring</strong>. <a href="/cart">Back to cart</a>'
    var title = document.querySelector('.product-single__title, main h1')
    if (title) {
      title.parentNode.insertBefore(banner, title.nextSibling)
    } else {
      form.parentNode.insertBefore(banner, form)
    }

    var label = btn.querySelector('[data-add-to-cart-text]') || btn
    label.textContent = 'Update ring'

    // Mark the edit before anything else sees the click: the options app handles "Add" itself (and stops
    // other listeners on the button) when a paid upgrade is selected, so listen at the window in the capture phase.
    function remember() {
      try {
        sessionStorage.setItem(PENDING, JSON.stringify({
          key: line.key, productId: line.product_id, qty: line.quantity, ts: Date.now()
        }))
      } catch (e) {}
    }
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[name="add"], .add-to-cart, [data-add-to-cart], form[action*="/cart/add"] [type="submit"]')
      if (t) remember()
    }, true)
    window.addEventListener('submit', function (e) {
      var f = e.target
      if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) remember()
    }, true)
    // Belt and braces: any add-to-cart request made from this page counts as the update
    if (window.fetch) {
      var origFetch = window.fetch
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || ''
        if (/\/cart\/add/.test(url)) remember()
        return origFetch.apply(this, arguments)
      }
    }
    var origOpen = XMLHttpRequest.prototype.open
    XMLHttpRequest.prototype.open = function (method, url) {
      if (/\/cart\/add/.test(String(url))) remember()
      return origOpen.apply(this, arguments)
    }
  }

  function start() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json() })
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === editKey })[0]
        if (!line) return // already changed or removed; behave like a normal product page
        decorate(line)
        prefill(line, 0)
      })
      .catch(function () {})
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
